/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "dünən",
        "0": "bu gün",
        "1": "sabah",
        "future": {
          "one": "{0} gün ərzində",
          "other": "{0} gün ərzində"
        },
        "past": {
          "one": "{0} gün öncə",
          "other": "{0} gün öncə"
        }
      },
      "day-narrow": {
        "-1": "dünən",
        "0": "bu gün",
        "1": "sabah",
        "future": {
          "one": "{0} gün ərzində",
          "other": "{0} gün ərzində"
        },
        "past": {
          "one": "{0} gün öncə",
          "other": "{0} gün öncə"
        }
      },
      "day-short": {
        "-1": "dünən",
        "0": "bu gün",
        "1": "sabah",
        "future": {
          "one": "{0} gün ərzində",
          "other": "{0} gün ərzində"
        },
        "past": {
          "one": "{0} gün öncə",
          "other": "{0} gün öncə"
        }
      },
      "hour": {
        "0": "bu saat",
        "future": {
          "one": "{0} saat ərzində",
          "other": "{0} saat ərzində"
        },
        "past": {
          "one": "{0} saat öncə",
          "other": "{0} saat öncə"
        }
      },
      "hour-narrow": {
        "0": "bu saat",
        "future": {
          "one": "{0} saat ərzində",
          "other": "{0} saat ərzində"
        },
        "past": {
          "one": "{0} saat öncə",
          "other": "{0} saat öncə"
        }
      },
      "hour-short": {
        "0": "bu saat",
        "future": {
          "one": "{0} saat ərzində",
          "other": "{0} saat ərzində"
        },
        "past": {
          "one": "{0} saat öncə",
          "other": "{0} saat öncə"
        }
      },
      "minute": {
        "0": "bu dəqiqə",
        "future": {
          "one": "{0} dəqiqə ərzində",
          "other": "{0} dəqiqə ərzində"
        },
        "past": {
          "one": "{0} dəqiqə öncə",
          "other": "{0} dəqiqə öncə"
        }
      },
      "minute-narrow": {
        "0": "bu dəqiqə",
        "future": {
          "one": "{0} dəqiqə ərzində",
          "other": "{0} dəqiqə ərzində"
        },
        "past": {
          "one": "{0} dəqiqə öncə",
          "other": "{0} dəqiqə öncə"
        }
      },
      "minute-short": {
        "0": "bu dəqiqə",
        "future": {
          "one": "{0} dəqiqə ərzində",
          "other": "{0} dəqiqə ərzində"
        },
        "past": {
          "one": "{0} dəqiqə öncə",
          "other": "{0} dəqiqə öncə"
        }
      },
      "month": {
        "-1": "keçən ay",
        "0": "bu ay",
        "1": "gələn ay",
        "future": {
          "one": "{0} ay ərzində",
          "other": "{0} ay ərzində"
        },
        "past": {
          "one": "{0} ay öncə",
          "other": "{0} ay öncə"
        }
      },
      "month-narrow": {
        "-1": "keçən ay",
        "0": "bu ay",
        "1": "gələn ay",
        "future": {
          "one": "{0} ay ərzində",
          "other": "{0} ay ərzində"
        },
        "past": {
          "one": "{0} ay öncə",
          "other": "{0} ay öncə"
        }
      },
      "month-short": {
        "-1": "keçən ay",
        "0": "bu ay",
        "1": "gələn ay",
        "future": {
          "one": "{0} ay ərzində",
          "other": "{0} ay ərzində"
        },
        "past": {
          "one": "{0} ay öncə",
          "other": "{0} ay öncə"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "keçən rüb",
        "0": "bu rüb",
        "1": "gələn rüb",
        "future": {
          "one": "{0} rüb ərzində",
          "other": "{0} rüb ərzində"
        },
        "past": {
          "one": "{0} rüb öncə",
          "other": "{0} rüb öncə"
        }
      },
      "quarter-narrow": {
        "-1": "keçən rüb",
        "0": "bu rüb",
        "1": "gələn rüb",
        "future": {
          "one": "{0} rüb ərzində",
          "other": "{0} rüb ərzində"
        },
        "past": {
          "one": "{0} rüb öncə",
          "other": "{0} rüb öncə"
        }
      },
      "quarter-short": {
        "-1": "keçən rüb",
        "0": "bu rüb",
        "1": "gələn rüb",
        "future": {
          "one": "{0} rüb ərzində",
          "other": "{0} rüb ərzində"
        },
        "past": {
          "one": "{0} rüb öncə",
          "other": "{0} rüb öncə"
        }
      },
      "second": {
        "0": "indi",
        "future": {
          "one": "{0} saniyə ərzində",
          "other": "{0} saniyə ərzində"
        },
        "past": {
          "one": "{0} saniyə öncə",
          "other": "{0} saniyə öncə"
        }
      },
      "second-narrow": {
        "0": "indi",
        "future": {
          "one": "{0} saniyə ərzində",
          "other": "{0} saniyə ərzində"
        },
        "past": {
          "one": "{0} saniyə öncə",
          "other": "{0} saniyə öncə"
        }
      },
      "second-short": {
        "0": "indi",
        "future": {
          "one": "{0} saniyə ərzində",
          "other": "{0} saniyə ərzində"
        },
        "past": {
          "one": "{0} saniyə öncə",
          "other": "{0} saniyə öncə"
        }
      },
      "week": {
        "-1": "keçən həftə",
        "0": "bu həftə",
        "1": "gələn həftə",
        "future": {
          "one": "{0} həftə ərzində",
          "other": "{0} həftə ərzində"
        },
        "past": {
          "one": "{0} həftə öncə",
          "other": "{0} həftə öncə"
        }
      },
      "week-narrow": {
        "-1": "keçən həftə",
        "0": "bu həftə",
        "1": "gələn həftə",
        "future": {
          "one": "{0} həftə ərzində",
          "other": "{0} həftə ərzində"
        },
        "past": {
          "one": "{0} həftə öncə",
          "other": "{0} həftə öncə"
        }
      },
      "week-short": {
        "-1": "keçən həftə",
        "0": "bu həftə",
        "1": "gələn həftə",
        "future": {
          "one": "{0} həftə ərzində",
          "other": "{0} həftə ərzində"
        },
        "past": {
          "one": "{0} həftə öncə",
          "other": "{0} həftə öncə"
        }
      },
      "year": {
        "-1": "keçən il",
        "0": "bu il",
        "1": "gələn il",
        "future": {
          "one": "{0} il ərzində",
          "other": "{0} il ərzində"
        },
        "past": {
          "one": "{0} il öncə",
          "other": "{0} il öncə"
        }
      },
      "year-narrow": {
        "-1": "keçən il",
        "0": "bu il",
        "1": "gələn il",
        "future": {
          "one": "{0} il ərzində",
          "other": "{0} il ərzində"
        },
        "past": {
          "one": "{0} il öncə",
          "other": "{0} il öncə"
        }
      },
      "year-short": {
        "-1": "keçən il",
        "0": "bu il",
        "1": "gələn il",
        "future": {
          "one": "{0} il ərzində",
          "other": "{0} il ərzində"
        },
        "past": {
          "one": "{0} il öncə",
          "other": "{0} il öncə"
        }
      }
    },
    "locale": "az-Latn"
  });
}